export const FAQ_CONSTS = {
    GET_FAQS: "GET_FAQS",
    CREATE_FAQ: "CREATE_FAQ",
    UPDATE_FAQS_POSITIONS: "UPDATE_FAQS_POSITIONS",
    UPDATE_FAQ_BY_ID: "UPDATE_FAQ_BY_ID",
    DELETE_FAQ_BY_ID: "DELETE_FAQ_BY_ID",
};